<script>
    import {closeOrderItem, screensStore} from "../core/screens-manager.js";
    import {decrementItemInCart, incrementItemInCart} from "../cart/cart-store.js";
    import {publishConfigStore} from "../core/app-store.js";
    import {onDestroy} from "svelte";
    import {t} from "../core/i18n/language-store.js";

    let data = null;

    const subscribes = [
        screensStore.subscribe(x => data = x?.orderItemData)
    ];

    const closeHandler = () => {
        closeOrderItem();
    }

    const decrementHandler = () => {
        decrementItemInCart(data.record, data.record.prices[data.priceIndex], data.priceIndex);
    }

    const incrementHandler = () => {
        incrementItemInCart(data.record, data.record.prices[data.priceIndex], data.priceIndex);
    }

    onDestroy(() => {
        for (let i = 0; i < subscribes.length; i++){
            subscribes[i]();
        }
    });
</script>

<style>
    .title {
        font-size: 1.25rem;
        font-weight: 400;
    }
    .close-backdrop {
        background: var(--backdrop-color);
        display: block;
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 1000;
    }
    .description {
        font-weight: 200;
        max-height: 30vh;
        overflow-y: auto;
    }
    .order-item-container {
        display: none;
    }
    .order-item-container--opened {
        position: fixed;
        width: 100vw;
        height: 100vh;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        padding-bottom: .5rem;
        z-index: 1000;
    }
    .content {
        display: flex;
        gap: 0.5rem;
        padding: 1rem;
        border-radius: .75rem;

        background: var(--bg-color);
        box-shadow: 0 0 16px 0 rgba(0, 0, 0, 0.15);

        width: calc(100vw - 1rem);
        margin-left: .5rem;
        margin-right: .5rem;
        margin-bottom: .5rem;

        z-index: 1001;
    }
    @media (min-width: 524px) {
        .order-item-container--opened {
            align-items: center;
        }
        .content {
            max-width: 500px;
            box-shadow: 0 10px 24px 0 rgba(0, 0, 0, .15);
            max-height: calc(100vh - 10rem);
            min-height: unset;
            bottom: unset;
        }
        .counter-button {
            cursor: pointer;
        }
    }

    .info {
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: 100%;
    }
    .info .title {}

    .price {
        font-weight: 600;
        font-size: 1.25rem;
    }
    .weight {
        color: var(--secondary-font-color);
        font-size: 0.85em;
    }
    .buttons-block {
        flex: 1 1;
        display: flex;
        justify-content: end;
        align-items: center;
        gap: 1rem;
        background: var(--button-primary-bg-color);
        color: var(--button-primary-text-color);
        border-radius: .75rem;
        padding: .5rem .75rem;
    }
    .counter-button {
        font-size: 1.25rem;
        height: 1.25rem;
        padding: 0;
        border: none;
        background: none;
        color: inherit;
        font-family: inherit;
        transition: transform .2s ease;
    }
    .counter-button:active {
        transform: scale(1.2);
    }
    .count {
        font-size: 1.25rem;
        font-family: var(--font-2);
        min-width: 1rem;
        text-align: center;
    }
    hr {
        width: 100%;
        border: none;
        border-top: 1px solid var(--main-font-color);
        opacity: .1;
    }
</style>

{#if ($screensStore.orderItemOpened)}
    <div class="order-item-container {$screensStore.orderItemOpened ? 'order-item-container--opened' : ''}">

        <div class="close-backdrop fade-in-animation" on:click={closeHandler}></div>

        {#if (data?.record && data?.record?.prices)}
        <div     class="content stick-bottom slide-up-animation">
            <div class="info gap-05">
                <div class="title">{data?.record?.name || $t('cart.unnamed')}</div>
                {#if (data?.record?.description) }
                <div class="description wrap-anywhere">{data?.record?.description}</div>
                {/if}

                <hr>

                <div class="flex-between ai-center">

                    <div class="flex-column">

                        <div class="price">
                            <strong>
                                {data?.record?.prices[data.priceIndex].price || ''}

                                {#if ($publishConfigStore?.currency)}
                                    {$publishConfigStore?.currency}
                                {/if}
                            </strong>
                        </div>

                        {#if (data?.record?.prices[data.priceIndex].weight)}
                            <div class="weight">{data?.record?.prices[data.priceIndex].weight}</div>
                        {/if}
                    </div>

                    <div>
                        <div class="buttons-block">
                            <button class="counter-button">
                                <span on:click|stopPropagation={() => decrementHandler()}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="ai ai-CircleMinus"><path d="M16 12H8"/><circle cx="12" cy="12" r="10"/></svg>
                                </span>
                            </button>

                            <span class="count">{data?.record?.prices[data.priceIndex]._count}</span>

                            <button class="counter-button">
                                <span on:click|stopPropagation={() => incrementHandler()}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="ai ai-CirclePlus"><path d="M12 8v4m0 0v4m0-4h4m-4 0H8"/><circle cx="12" cy="12" r="10"/></svg>
                                </span>
                            </button>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        {/if}

    </div>
{/if}
